/**
 * URL関連のユーティリティ関数
 */

/**
 * テキストが有効なURL形式かどうかを判定する
 * http:// または https:// で始まるURLのみを有効とする
 */
export function isValidUrl(text: string): boolean {
  try {
    const url = new URL(text);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

/**
 * URLからドメイン名を抽出する
 */
export function extractDomain(url: string): string {
  try {
    return new URL(url).hostname;
  } catch {
    return "";
  }
}
